<template>
  <div class="downlinesearch-card">
    <form @submit.prevent="searchDownline">
      <div class="form-group row">
        <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
          <label>First Name</label>
          <input
            type="text"
            class="downlinesearch-field"
            placeholder="Enter First Name"
            v-model="filters.agent_fname"
          />
        </div>
        <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
          <label>Last Name</label>
          <input
            type="text"
            class="downlinesearch-field"
            placeholder="Enter Last Name"
            v-model="filters.agent_lname"
          />
        </div>
        <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
          <label>Rep Phone</label>
          <input
            type="text"
            class="downlinesearch-field"
            placeholder="Enter Rep Phone"
            v-model="filters.agent_phone"
          />
        </div>
        <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
          <label>Rep Email</label>
          <input
            type="email"
            class="downlinesearch-field"
            placeholder="Rep Email"
            v-model="filters.agent_email"
          />
        </div>
      </div>

      <div class="form-group row">
        <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
          <label>Rep Code</label>
          <input
            type="text"
            class="downlinesearch-field"
            placeholder="Enter Rep Code"
            v-model="filters.agent_code"
          />
        </div>
        <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
          <label>Upline Rep Code</label>
          <input
            type="text"
            class="downlinesearch-field"
            placeholder="Enter Upline Rep Code"
            v-model="filters.upline_code"
          />
        </div>
        <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
          <label>Upline Rep Name</label>
          <input
            type="text"
            class="downlinesearch-field"
            placeholder="Enter Upline Rep Name"
            v-model="filters.upline_name"
          />
        </div>
        <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
          <label>Status</label>
          <multiselect
            name="state"
            v-model="filters.agent_status"
            placeholder="Select Status"
            :options="status.map((type) => type.value)"
            :custom-label="(opt) => status.find((x) => x.value == opt).text"
          />
        </div>
      </div>

      <div class="form-group row">
        <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
          <label>State</label>
          <multiselect
            name="state"
            v-model="filters.agent_state"
            placeholder="Select State"
            :options="states.map((type) => type.value)"
            :custom-label="(opt) => states.find((x) => x.value == opt).text"
          />
        </div>
        <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
          <label>Group</label>
          <multiselect
            name="group"
            v-model="filters.group_id"
            placeholder="Select Group"
            :options="groups.map((type) => type.group_id)"
            :custom-label="
              (opt) => groups.find((x) => x.group_id == opt).group_name
            "
            :options-limit="100"
            :internal-search="false"
            :local-search="false"
            @search-change="searchHandler"
            @open="getGroups"
          />
        </div>
        <!-- <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
          <label>Number of Active Clients greater than</label>
          <input type="range" :min="0" :max="5000" class="downlinesearch-rangefield mt-2" placeholder="Policy count"
            v-model="filters.policy_count" style="cursor: pointer;" />
          <div class="d-flex justify-content-between" style="font-size: 12px; margin-top: -5px;">
            <span class="low-count">{{ filters.policy_count??0 }}</span>
            <span class="high-count">5000</span>
          </div>
        </div> -->
        <div v-if="!isEnrollPrime" class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
          <label>Level</label>
          <multiselect name="Level" v-model="filters.agent_level" placeholder="Select Level" :options="level_options"
            :multiple="true" :options-limit="100" :internal-search="true" :local-search="true"
            @search-change="searchHandler" @open="getGroups" />
        </div>
        <div  v-if="!isEnrollPrime" class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
          <label>Agent Contracts</label>
          <multiselect name="Agent Contracts" v-model="filters.contract" placeholder="Select Agent Contract"
            :options="contractOptions.map((name) => name.value)" :options-limit="100" :multiple="true"
            :internal-search="true" :local-search="true" />
        </div>
        <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
          <label>Products</label>
          <multiselect name="Products" v-model="filters.product" placeholder="Select Product"
            :options="planOptions.map((plan) => plan.plan_name)"  :options-limit="100"  :multiple="true" :internal-search="true"
            :local-search="true" @search-change="searchPlan"  />
        </div>
        <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
            <label>Business Name</label>
            <input
              v-model="filters.business_name"
              type="text"
              class="downlinesearch-field"
              placeholder="Enter Business Name"
            />
          </div>

            <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
            <label>SSN</label>
            <input
              v-model="filters.agent_ssn"
              type="text"
              class="downlinesearch-field"
              placeholder="Enter last 4 digits or full 9-digit SSN"
               maxlength="9"
              pattern="[0-9]*"
              @input="filters.agent_ssn = filters.agent_ssn.replace(/\D/g, '').slice(0, 9)"
            />
          </div>

               <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
            <label>EIN</label>
            <input
              v-model="filters.tin"
              type="text"
              class="downlinesearch-field"
              placeholder="Enter last 4 digits or full 9-digit EIN"
              maxlength="9"
              pattern="[0-9]*"
              @input="filters.tin = filters.tin.replace(/\D/g, '').slice(0, 9)"
            />
          </div>
 
         <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
          <label>Routing Number</label>
          <input
            v-model="filters.routing_number"
            type="text"
            class="downlinesearch-field"
            placeholder="Routing Number"
            maxlength="9"
            pattern="\d{9}"
            @input="filters.routing_number = filters.routing_number.replace(/\D/g, '').slice(0, 9)"
          />
          <small v-if="filters.routing_number && filters.routing_number.length !== 9" style="color:red">
            Please enter exactly 9 digits.
          </small>
        </div>


          <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
            <label>Bank Account Number (Last 4 digits)</label>
            <input
              v-model="filters.account_number"
              type="text"
              class="downlinesearch-field"
              placeholder="Bank Account Number (Last 4 digits)"
              maxlength="4"
              pattern="[0-9]*"
              @input="filters.account_number = filters.account_number.replace(/\D/g, '').slice(0, 4)"
            />
            <small v-if="filters.account_number && filters.account_number.length !== 4" style="color:red">
              Please enter exactly 4 digits.
            </small>
          </div>

              <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
                <label>Account Name</label>
                <input
                  v-model="filters.account_name"
                  type="text"
                  class="downlinesearch-field"
                  placeholder="Account Name"
                />
              </div>

              <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
                <label>Rep Type</label>
                <multiselect
                  name="rep_type"
                  v-model="filters.rep_type"
                  placeholder="Select Rep Type"
                  :options="repTypeOptions.map((t) => t.value)"
                  :custom-label="(opt) => repTypeOptions.find((x) => x.value == opt).text"
                />
              </div>

        </div>

      <div class="form-group row">
        <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
          <label>Enrollment From</label>
          <input
            type="date"
            class="downlinesearch-field"
            v-model="filters.enrollment_from"
            :max="today"
            @change="onEnrollmentFromChange"
          />
        </div>
        <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4">
          <label>Enrollment To</label>
          <input
            type="date"
            class="downlinesearch-field"
            v-model="filters.enrollment_to"
            :disabled="!filters.enrollment_from"
            :min="filters.enrollment_from"
            :max="today"
          />
        </div>
        <div class="col-xxl-3 col-xl-3 col-lg-6 col-md-6 mb-4 d-flex align-items-center" style="padding-top: 28px;">
          <div class="d-flex align-items-center">
            <input
              type="checkbox"
              id="non_submitted_case"
              :true-value="1"
              :false-value="0"
              v-model="filters.non_submitted_case"
              style="width:18px; height:18px; cursor:pointer; margin-right:8px; flex-shrink:0;"
            />
            <label for="non_submitted_case" class="mb-0" style="cursor:pointer; font-weight:500;">
              Non Submitted Cases
            </label>
          </div>
        </div>
      </div>

      <div class="row justify-content-md-end align-items-end">
        <!-- Quick Date Buttons -->
        <div class="col-12 col-xxl-auto col-xl-auto mb-3 mb-xl-0">
          <div class="quick-date-btns d-flex align-items-center gap-2 flex-wrap">
            <button
              type="button"
              class="quick-date-btn"
              :class="{ active: activeQuickFilter === 'all' }"
              @click="$emit('quick-filter', 'all')"
              title="All reps"
            >
              <i class="fas fa-list me-1"></i>
              All Reps
            </button>
            <button
              type="button"
              class="quick-date-btn"
              :class="{ active: activeQuickFilter === 'today' }"
              @click="$emit('quick-filter', 'today')"
              title="Reps signed up today"
            >
              <i class="fas fa-calendar-day me-1"></i>
              Reps Today
            </button>
            <button
              type="button"
              class="quick-date-btn"
              :class="{ active: activeQuickFilter === 'week' }"
              @click="$emit('quick-filter', 'week')"
              title="Reps signed up this week"
            >
              <i class="fas fa-calendar-week me-1"></i>
              Reps This Week
            </button>
            <button
              type="button"
              class="quick-date-btn"
              :class="{ active: activeQuickFilter === 'month' }"
              @click="$emit('quick-filter', 'month')"
              title="Reps signed up this month"
            >
              <i class="fas fa-calendar-alt me-1"></i>
              Reps This Month
            </button>
          </div>
        </div>
        <div class="col-xxl-2 col-xl-3">
          <button type="submit" class="univ-btn">Search</button>
        </div>
           <div class="col-xxl-2 col-xl-3">
          <button type="" class="univ-btn" @click="goToExportLogs">View Export Logs</button>
        </div>
        <div class="col-xxl-2 col-xl-3">
          <button type="button" class="univ-btn" @click="exportRep"><i class="fas fa-file-export"></i> Export</button>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import Api from "@/resource/Api";
import Helper from "@/resource/Helper";
import { mapGetters } from 'vuex';
import isEnrollPrimeUtil from '@/utils/isEnrollPrimeUtil';
export default {
  name: "DownlineRepListFilter",
  props: {
    filters: {
      required: true,
      type: Object,
    },
    activeQuickFilter: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    today: new Date().toISOString().split("T")[0],
    states: Helper.getStates(),
    groups: [],
    level_options: [],
    planOptions: [],
    status: [
      { text: "Active", value: "A" },
      { text: "Pending", value: "P" },
      { text: "Disabled", value: "D" },
      { text: "Suspended", value: "S" },
      { text: "Deleted", value: "R" },
    ],
    repTypeOptions: [
      { text: "All", value: "all" },
      { text: "Direct", value: "direct" },
      { text: "Downline", value: "downline" },
    ],
    contractOptions: [
      { name: "Smart Contract", value: "Smart Contract" },
      { name: "EWA Contract (Union Only)", value: "EWA Contract (Union Only)" },
      { name: "BEX Ancillary Contract", value: "BEX Ancillary Contract" },
      { name: "BEX Premier Contract", value: "BEX Premier Contract" },
      { name: "GPBP (FEGLI) Contract", value: "GPBP (FEGLI) Contract" },
      { name: "Patriot Medical", value: "Patriot Medical" },
      { name: "Patriot Medical Multi level contract", value: "Patriot Medical - Multi Level Contract" },
      { name: "Category Smart ancillary contract", value: "Category Smart ancillary contract" }
    ]
  }),
  computed: {
    ...mapGetters(["rep"]), 
    isEnrollPrime() {
      return isEnrollPrimeUtil.isEnrollPrime();
    }
  },

  methods: {
    onEnrollmentFromChange() {
      this.filters.enrollment_to = "";
    },
    goToExportLogs() {
      this.$router.push({ 
        name: 'ViewExportLog', 
        params: { type: 'downline-reps' } 
      })
    },
    searchHandler(query) {
      if (query.length > 2) {
        this.getGroups(query);
      }
    },
    searchPlan(query) {
      if (query.length > 2) {
        this.getPlans(query);
      }
    },
    getGroups(query = null) {
      let url;
      const baseUrl = `v2/get-rep-group-list?size=100`;
      if (query) {
        url = `${baseUrl}&group_name=${query}`;
      } else {
        url = baseUrl;
      }
      Api.get(url)
        .then((res) => {
          this.groups = res.data.data;
        })
        .catch(() => {
          console.log("Failed to fetch groups");
        });
    },
    getPlans(query = null) {
      let url;
      const baseUrl = `v2/get-rep-plan-configuration?size=100?agent_id=${this.rep.id}`;
      if (query) {
        url = `${baseUrl}&plan_name=${query}`;
      } else {
        url = baseUrl;
      }
      Api.get(url)
  .then((res) => {
    const uniquePlans = [];
    const seenPlanIds = new Set();

    res.data.records.forEach((plan) => {
      if (!seenPlanIds.has(plan.plan_id)) {
        seenPlanIds.add(plan.plan_id);
        uniquePlans.push(plan);
      }
    });

    this.planOptions = uniquePlans;
  })
  .catch(() => {
    console.log("Failed to fetch plans");
  });

    },
  searchDownline() {
  const ssn = (this.filters.agent_ssn || '').trim();
  const tin = (this.filters.tin || '').trim();

  const ssnLen = ssn.length;
  const tinLen = tin.length;

  const isSSNValid = ssnLen === 9 || ssnLen === 4 || ssnLen === 0;
  const isTINValid = tinLen === 9 || tinLen === 0;

  // If both are present but invalid
  if (!isSSNValid && !isTINValid) {
    this.$notify('Please enter a valid SSN (last 4 or full 9 digits) or EIN with 9 digits.', 'error');
    return;
  }

  if (!isSSNValid) {
    this.$notify('Please enter a valid SSN (last 4 or full 9 digits).', 'error');
    return;
  }

  if (!isTINValid) {
    this.$notify('Please enter a valid EIN with 9 digits.', 'error');
    return;
  }

  this.$emit("onSearch", this.filters);
},

 async exportRep() {
      let url;
      if (this.filters) {
        let filterUrl = Helper.objToUrlParams(this.filters);
        url = this.$endpoint.EXPORT_REP_LIST_FORMATTED + `?${filterUrl}`;
      } else {
        url = this.$endpoint.EXPORT_REP_LIST_FORMATTED;
      }
      let loader = this.$loading.show();
      await Api
        .get(url)
        .then(({data}) => {
          this.$notify(data.data, 'success');
        })
        .catch(err => {
          console.log(err)
          this.$notify('Something went wrong. Please Try Again.', 'error');
        })
        .finally(() => {
          loader.hide();
        });
    },

  },
  created() {
    this.getGroups();
    this.getPlans();
    const maxLevel = Math.max(this.rep.agentLevel, this.rep.agentLevel2);
    this.level_options = Array.from({ length: maxLevel }, (_, i) => i + 1);
  },
};
</script>
<style>
div.multiselect{
  margin-left: 0 !important;
  width:100% !important;
}
input[type="range"] {
  accent-color: #007bff; 
}
.downlinesearch-rangefield {
  width: 100%;
  cursor: pointer;
  padding: 0; 
  margin: 0;
}
.quick-date-btns {
  gap: 6px;
}
.quick-date-btn {
  font-size: 13px;
  font-weight: 600;
  padding: 6px 14px;
  border-radius: 6px;
  border: 1.5px solid #d0d0d0;
  background-color: #f8f9fa;
  color: #444;
  cursor: pointer;
  transition: all 0.18s ease;
  white-space: nowrap;
  height: 36px;
  line-height: 1;
}
.quick-date-btn:hover {
  background-color: #e8f0fe;
  border-color: #4a6cf7;
  color: #4a6cf7;
}
.quick-date-btn.active {
  background-color: #4a6cf7;
  border-color: #4a6cf7;
  color: #fff;
  box-shadow: 0 2px 8px rgba(74, 108, 247, 0.22);
}
@media (max-width: 768px) {
  .quick-date-btn {
    font-size: 12px;
    padding: 5px 10px;
  }
}
</style>
